import * as React from 'react';
import {connect} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {FilterButton} from 'shells/filter-button/filter-button';
import {SAVED_LIST_TOUR_FILTER_BUTTON_ID} from 'shells/tours/tours';
import {useNutshellTour} from 'shells/tours/use-nutshell-tour';

import {EntityList} from '../../../entity-list';
import type {NutshellState} from '../../../store';

type OwnProps = {
    activeFilters: FilterObject[];
    progressTour?: () => void;
};
type StateProps = {
    isFilterDrawerOpen: boolean;
};
type DispatchProps = {
    onToggleFilterDrawer: () => any;
};
type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        isFilterDrawerOpen: EntityList.getIsFilterDrawerOpen(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onToggleFilterDrawer: () => {
            dispatch(EntityList.toggleShowFilterDrawer());
        },
    };
}

class EntityListFilterButtonComponent extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.onToggleFilterDrawer();
        if (this.props.progressTour) {
            // We need to wait for the filter drawer to open before progressing
            // the tour
            requestAnimationFrame(() => {
                // @ts-expect-error
                this.props.progressTour();
            });
        }
    };

    render() {
        return (
            <div id={SAVED_LIST_TOUR_FILTER_BUTTON_ID}>
                <FilterButton
                    onClick={this.handleClick}
                    isOpen={this.props.isFilterDrawerOpen}
                    activeFilters={this.props.activeFilters}
                />
            </div>
        );
    }
}

// @ts-expect-error
const ConnectedButton = connect<Props, OwnProps, _, _, _, _>(
    mapStateToProps,
    mapDispatchToProps
)(EntityListFilterButtonComponent);

function EntityListFilterButtonWithTour(props: {activeFilters: FilterObject[]}) {
    const {progressTour} = useNutshellTour();

    return <ConnectedButton activeFilters={props.activeFilters} progressTour={progressTour} />;
}

export const EntityListFilterButton = EntityListFilterButtonWithTour;
